import Glide from '@glidejs/glide';
import { onReady } from './utils.js';

onReady( function() {
	const galleries = document.querySelectorAll( '.wp-block-gallery' );
	galleries.forEach( ( gallery ) => {
		const track = document.createElement( 'div' );
		track.className = 'glide__track';
		track.setAttribute( 'data-glide-el', 'track' );

		const slides = document.createElement( 'div' );
		slides.className = 'glide__slides';

		const controls = document.createElement( 'div' );
		controls.className = 'glide__arrows';
		controls.setAttribute( 'data-glide-el', 'controls' );
		controls.innerHTML = '<button class="glide__arrow glide__arrow--left" data-glide-dir="<">Предишна</button><button class="glide__arrow glide__arrow--right" data-glide-dir=">">Следваща</button>';

		gallery.childNodes.forEach( ( element ) => {
			if ( element.nodeType !== Node.ELEMENT_NODE ) {
				return;
			}
			element.classList.add( 'glide__slide' );
			slides.append( element );
		} );

		track.append( slides );

		gallery.classList.add( 'glide' );
		gallery.append( track );
		gallery.append( controls );

		gallery.glide = new Glide( gallery, {
			type: 'carousel', // slider | carousel
			focusAt: 'center',
			perView: 1,
			peek: window.innerWidth > 1000 ? 100 : 0,
			gap: 20,
		} ).mount();
	} );
} );
